<template>
  <q-item
    dense
    @click="$emit('click')"
  >
    <slot name="before" />

    <q-item-section>
      <q-item-label>
        <span class="text-bold">
          {{ item.name }}
        </span>
      </q-item-label>
    </q-item-section>

    <q-item-section v-if="item.system_type" side>
      <q-chip
        dense
        size="12px"
        class="q-ma-none"
        :style="{'background-color': changeColorBrightness(item.system_type.color, 89)}"
      >
        {{ item.system_type.name }}
      </q-chip>
    </q-item-section>

    <slot name="after" />
  </q-item>
</template>

<script>
export default {
  props: {
    item: {
      type: Object,
      required: true
    }
  },
  emits: ['click']
}
</script>
